import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { combineLatest } from 'rxjs/observable/combineLatest';
import 'rxjs/add/operator/finally';

import { StorageService } from '../../../core/services';
import { requiredValidator } from '../../validators/index';

interface Attachment {
  name: string;
  type: string;
  path: string;
  url?: string;
}

interface Pending {
  file: File;
  form: FormGroup;
}

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
})
export class UploadModalComponent {
  active = false;
  pending: Pending[];
  uploading = false;
  @Input() for = null;
  @Output() onUploaded = new EventEmitter<Attachment[]>();

  constructor(private storage: StorageService) {}

  open(files: File[]) {
    this.pending = files.map(file => {
      const form = new FormGroup({
        name: new FormControl(file.name, requiredValidator()),
        type: new FormControl(null, requiredValidator()),
      });
      return { file, form };
    });

    this.active = true;
  }

  close() {
    this.pending = null;
    this.active = false;
  }

  remove(attachment: Pending) {
    this.pending = this.pending.filter(a => a !== attachment);

    if (! this.pending.length) {
      this.close();
    }
  }

  upload() {
    // Ensure forms is valid
    if (! this.valid) {
      return;
    }

    this.uploading = true;

    // Create upload observables
    const uploads = this.pending.map(attachment =>
      this.storage.upload(attachment.file).map(upload => {
        return {
          ...upload,
          name: attachment.form.value.name,
          type: attachment.form.value.type,
        };
      })
    );

    // Fire observers and collect results
    // Woo, beautiful parallel uploads
    combineLatest(...uploads)
      .finally(() => this.uploading = false)
      .subscribe(attachments => {
        this.onUploaded.emit(attachments);
        this.close();
      });
  }

  get valid() {
    return this.pending
        && this.pending.every(attachment => attachment.form.valid);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notes/upload-modal.component.ts